import React from 'react'

import banner from '../../assets/images/TestBanner.png'
import StreamerCardsContainer from '../streamer-cards/StreamerCardsContainer'

const RootRoute = () => (
  <>
    <img src={banner} alt='' className='img_stretched' />
    <StreamerCardsContainer />
  </>
)

export default RootRoute
